
import { onSetInitDefaultFiltersCatalogLocalStorage } from '~/helpers/onSetInitDefaultFiltersCatalogLocalStorage'
import {
  RESPONSE_STATUS_BAD_REQUEST,
  RESPONSE_STATUS_UNAUTHORIZED,
} from '~/ZenOne-StoryBook/helpers/response'
import { loginUser } from '~/helpers/user'

const keyEnter = 'Enter'
export default {
  name: 'LoginForm',
  data() {
    return {
      onSetInitDefaultFiltersCatalogLocalStorage,
      focusEmail: false,
      focusPassword: false,
      error: false,
      show: false,
      email: '',
      emailLabel: 'Email',
      password: '',
      passwordLabel: 'Password',
      isLoading: false,
      emailWasBlurred: false,
      passwordWasBlurred: false,
      loginButtonWasClicked: false,
      passwordRules: [
        (value) => {
          if (this.passwordWasBlurred || this.loginButtonWasClicked) {
            return value !== ''
          }
          return true
        },
      ],
      emailRules: [
        () => {
          if (this.emailWasBlurred || this.loginButtonWasClicked) {
            return this.validateEmail()
          }
          return true
        },
      ],
    }
  },
  computed: {
    showPasswordError() {
      return (
        (this.passwordWasBlurred || this.loginButtonWasClicked) &&
        this.password === ''
      )
    },
    showEmailError() {
      return (
        (this.emailWasBlurred || this.loginButtonWasClicked) &&
        !this.validateEmail()
      )
    },
    showPasswordLabel() {
      return this.focusPassword || (!this.focusPassword && this.password !== '')
    },
    showEmailLabel() {
      return this.focusEmail || (!this.focusEmail && this.email !== '')
    },
    isLoginBtnDisabled() {
      return this.isLoading || this.password === '' || !this.validateEmail()
    },
  },
  mounted() {
    onSetInitDefaultFiltersCatalogLocalStorage()
    document.addEventListener('keypress', this.onEnterLogin)
  },
  beforeDestroy() {
    document.removeEventListener('keypress', this.onEnterLogin)
  },
  methods: {
    resetServerError() {
      if (this.error) {
        this.error = false
      }
    },
    passwordFocusInHandler() {
      this.focusPassword = true
      this.resetServerError()
    },
    passwordFocusOutHandler() {
      if (!this.passwordWasBlurred) {
        this.passwordWasBlurred = true
      }
      this.focusPassword = false
    },
    emailFocusInHandler() {
      this.focusEmail = true
      this.resetServerError()
    },
    emailFocusOutHandler() {
      if (!this.emailWasBlurred) {
        this.emailWasBlurred = true
      }
      this.focusEmail = false
    },
    async onEnterLogin(event) {
      if (event.key === keyEnter) {
        await this.login()
      }
    },
    validateEmail() {
      const { email = '' } = this
      if (email !== '') {
        return /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i.test(
          email
        )
      }
      return false
    },
    async login() {
      this.resetServerError()
      if (!this.loginButtonWasClicked) {
        this.loginButtonWasClicked = true
      }

      try {
        this.isLoading = true

        const data = {
          email: this.email,
          password: this.password
        }
        await loginUser(data, this.$auth, this.$store)

        await this.$router.push(`/`)
      } catch (e) {
        console.error('login', e)
        if (
          [RESPONSE_STATUS_BAD_REQUEST, RESPONSE_STATUS_UNAUTHORIZED].includes(
            e?.response?.status
          )
        ) {
          this.error = true
        }
      } finally {
        this.isLoading = false
      }
    },
  },
}
